import type { IconType } from "react-icons";
import {
  FaAnchor,
  FaArrowDown,
  FaArrowLeft,
  FaArrowRight,
  FaArrowUp,
  FaBed,
  FaBell,
  FaBicycle,
  FaBriefcase,
  FaBus,
  FaCalendar,
  FaCamera,
  FaCar,
  FaCheck,
  FaCheckCircle,
  FaClock,
  FaCloud,
  FaComments,
  FaCompass,
  FaCreditCard,
  FaFile,
  FaFilter,
  FaFire,
  FaGift,
  FaGlobe,
  FaHandshake,
  FaHeart,
  FaHome,
  FaHourglass,
  FaImage,
  FaLandmark,
  FaLink,
  FaList,
  FaLocationArrow,
  FaMap,
  FaMapMarkedAlt,
  FaMapPin,
  FaMedal,
  FaMicrophone,
  FaMoon,
  FaMusic,
  FaPalette,
  FaPhone,
  FaPlane,
  FaPlaneDeparture,
  FaPlay,
  FaPlus,
  FaShieldAlt,
  FaShip,
  FaShuttleVan,
  FaSpinner,
  FaStar,
  FaSuitcaseRolling,
  FaSun,
  FaTimes,
  FaTrain,
  FaTrophy,
  FaUmbrella,
  FaUser,
  FaUsers,
  FaUtensils,
  FaWallet,
  FaWaveSquare,
  FaWifi,
  FaBolt,
} from "react-icons/fa";

export type IconOption = {
  key: string;
  label: string;
  icon: IconType;
};

export const PACKAGE_ICON_OPTIONS: IconOption[] = [
  { key: "home", label: "Home", icon: FaHome },
  { key: "bed", label: "Bed", icon: FaBed },
  { key: "map-pin", label: "Map Pin", icon: FaMapPin },
  { key: "map", label: "Map", icon: FaMap },
  { key: "map-marked-alt", label: "Map Marked", icon: FaMapMarkedAlt },
  { key: "compass", label: "Compass", icon: FaCompass },
  { key: "globe", label: "Globe", icon: FaGlobe },
  { key: "location-arrow", label: "Navigation", icon: FaLocationArrow },
  { key: "calendar", label: "Calendar", icon: FaCalendar },
  { key: "clock", label: "Clock", icon: FaClock },
  { key: "hourglass", label: "Timer", icon: FaHourglass },
  { key: "alarm-clock", label: "Alarm", icon: FaClock },
  { key: "sun", label: "Sun", icon: FaSun },
  { key: "moon", label: "Moon", icon: FaMoon },
  { key: "cloud", label: "Cloud", icon: FaCloud },
  { key: "wave-square", label: "Waves", icon: FaWaveSquare },
  { key: "umbrella", label: "Umbrella", icon: FaUmbrella },
  { key: "fire", label: "Flame", icon: FaFire },
  { key: "star", label: "Star", icon: FaStar },
  { key: "heart", label: "Heart", icon: FaHeart },
  { key: "check-circle", label: "Badge Check", icon: FaCheckCircle },
  { key: "medal", label: "Medal", icon: FaMedal },
  { key: "trophy", label: "Trophy", icon: FaTrophy },
  { key: "gift", label: "Gift", icon: FaGift },
  { key: "wallet", label: "Wallet", icon: FaWallet },
  { key: "credit-card", label: "Credit Card", icon: FaCreditCard },
  { key: "plane", label: "Plane", icon: FaPlane },
  { key: "plane-departure", label: "Plane Departure", icon: FaPlaneDeparture },
  { key: "bus", label: "Bus", icon: FaBus },
  { key: "train", label: "Train", icon: FaTrain },
  { key: "car", label: "Car", icon: FaCar },
  { key: "bicycle", label: "Bike", icon: FaBicycle },
  { key: "shuttle-van", label: "Shuttle Van", icon: FaShuttleVan },
  { key: "suitcase-rolling", label: "Suitcase", icon: FaSuitcaseRolling },
  { key: "anchor", label: "Anchor", icon: FaAnchor },
  { key: "ship", label: "Ship", icon: FaShip },
  { key: "camera", label: "Camera", icon: FaCamera },
  { key: "image", label: "Image", icon: FaImage },
  { key: "music", label: "Music", icon: FaMusic },
  { key: "play", label: "Play", icon: FaPlay },
  { key: "microphone", label: "Mic", icon: FaMicrophone },
  { key: "phone", label: "Phone", icon: FaPhone },
  { key: "comments", label: "Message", icon: FaComments },
  { key: "users", label: "Users", icon: FaUsers },
  { key: "user", label: "User", icon: FaUser },
  { key: "briefcase", label: "Briefcase", icon: FaBriefcase },
  { key: "landmark", label: "Landmark", icon: FaLandmark },
  { key: "handshake", label: "Handshake", icon: FaHandshake },
  { key: "shield-alt", label: "Shield Alt", icon: FaShieldAlt },
  { key: "wifi", label: "Wifi", icon: FaWifi },
  { key: "filter", label: "Filter", icon: FaFilter },
  { key: "list", label: "List", icon: FaList },
  { key: "file", label: "File", icon: FaFile },
  { key: "link", label: "Link", icon: FaLink },
  { key: "spinner", label: "Loader", icon: FaSpinner },
  { key: "palette", label: "Palette", icon: FaPalette },
  { key: "bell", label: "Bell", icon: FaBell },
  { key: "bolt", label: "Zap", icon: FaBolt },
  { key: "arrow-up", label: "Arrow Up", icon: FaArrowUp },
  { key: "arrow-right", label: "Arrow Right", icon: FaArrowRight },
  { key: "arrow-down", label: "Arrow Down", icon: FaArrowDown },
  { key: "arrow-left", label: "Arrow Left", icon: FaArrowLeft },
  { key: "plus", label: "Plus", icon: FaPlus },
  { key: "check", label: "Check", icon: FaCheck },
  { key: "utensils", label: "Utensils", icon: FaUtensils },
  { key: "times", label: "Close", icon: FaTimes },
];

const toLookupToken = (value?: string | null) =>
  (value || "")
    .trim()
    .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
    .replace(/[\s_]+/g, "-")
    .replace(/[^a-zA-Z0-9-]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .replace(/--+/g, "-")
    .toLowerCase();

const stripFaPrefix = (value: string) => {
  if (value.startsWith("fa-")) return value.slice(3);
  if (value.startsWith("fa")) return value.slice(2).replace(/^-+/, "");
  return value;
};

const ICON_ALIASES: Record<string, string> = {
  hotel: "bed",
  accommodation: "bed",
  stay: "bed",
  transfer: "shuttle-van",
  transport: "shuttle-van",
  ferry: "ship",
  timer: "hourglass",
  alarm: "alarm-clock",
  navigation: "location-arrow",
  message: "comments",
  "message-circle": "comments",
  shield: "shield-alt",
};

const PACKAGE_ICON_MAP = new Map<string, IconType>();

PACKAGE_ICON_OPTIONS.forEach((option) => {
  PACKAGE_ICON_MAP.set(option.key, option.icon);
  PACKAGE_ICON_MAP.set(toLookupToken(option.label), option.icon);
});

export const resolvePackageIcon = (iconName?: string | null): IconType | undefined => {
  const normalizedRaw = stripFaPrefix(toLookupToken(iconName));
  if (!normalizedRaw) return undefined;

  const normalized = ICON_ALIASES[normalizedRaw] || normalizedRaw;
  return PACKAGE_ICON_MAP.get(normalized);
};
